<template>
  <div class="c-map-tabs">
    <div class="c-map-tabs__list" role="tablist" aria-label="Details">
      <button
        v-for="(tab, i) in tabs"
        v-bind:aria-controls="tab.panelId"
        v-bind:aria-selected="tab.selected"
        v-bind:class="{ 'is-active': activeIndex === i }"
        v-bind:key="i"
        v-bind:id="tab.tabId"
        v-bind:tabindex="tab.tabIndex"
        v-on:click="selectTab(i)"
        v-on:keyup="keyHashLookup($event.key, i)"
        ref="tab"
        class="c-map-tabs__button"
        role="tab"
      >
        {{ tab.title }}
      </button>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "MapTabs",
  data() {
    return {
      activeIndex: 0,
      tabs: [],
    };
  },
  created() {
    this.tabs = this.$children;
  },
  mounted() {
    this.setActiveTab();
  },
  methods: {
    setActiveTab(){
     this.$emit('activeTab', this.tabs[this.activeIndex].tabId);
    },
    keyHashLookup(key, index) {
      const keyHash = {
        ArrowLeft: () => {
          const leftIndex = index - 1;
          if (leftIndex >= 0) {
            this.selectTab(leftIndex);
          }
        },
        ArrowRight: () => {
          const rightIndex = index + 1;
          if (rightIndex <= this.tabs.length - 1) {
            this.selectTab(rightIndex);
          }
        },
      };

      if (!keyHash[key]) {
        return;
      }

      return keyHash[key]();
    },
    selectTab(activeIndex) {
      this.tabs.forEach((v, i) => (v.activeTab = i === activeIndex));
      this.activeIndex = activeIndex;
      this.setActiveTab();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/components/consumer/layered-map/MapTabs.vue